import { FC, useEffect } from 'react';
import { Flex, Button, TextInput, BoxV2 as Box } from 'portal-commons';
import { useForm, useController } from 'react-hook-form';

import { Modal } from '@/components';

type ActionType = 'review' | 'appealRejection' | 'deactivate';
interface NudgeCnpModalProps {
  open: boolean;
  type: ActionType;
  onCancel: () => void;
  onConfirm: (type: ActionType, data: { message: string }) => void;
  disabled?: boolean;
}

const NudgeCnpModal: FC<NudgeCnpModalProps> = ({
  open,
  type,
  onCancel,
  onConfirm,
  disabled = false,
}) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      message: '',
    },
  });

  const { field } = useController({
    control,
    name: 'message',
  });

  const handleSendClick = (data: { message: string }) => {
    onConfirm(type, data);
  };

  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open]);

  return (
    <Modal open={open} testId="campaignActionModal">
      <Flex
        sx={{
          fontSize: 'H300',
          color: 't.black80',
          flexDirection: 'column',
          gap: '30px',
          textAlign: 'center',
        }}
      >
        {type === 'review' && (
          <>
            <p>
              Are you sure you would like to{' '}
              <strong>nudge the CNP to Review</strong>? This will remind the
              upstream CNP to review the campaign.
            </p>
            <p>
              If yes, you may add an optional message below
              <br /> to send with your action.
            </p>
          </>
        )}
        {type === 'appealRejection' && (
          <>
            <p>
              Are you sure you would like to{' '}
              <strong>nudge the CNP to Appeal Rejection</strong>? This will
              notify the CNP that the rejected campaign has been updated and can
              be resubmitted.
            </p>
            <p>
              If yes, you may add an optional message below
              <br /> to send with your action.
            </p>
          </>
        )}
        {type === 'deactivate' && (
          <>
            <p>
              Are you sure you want to <strong>deactivate</strong> this
              campaign? <br />
              This action cannot be undone.
              <br />
              If you continue, your DCA will be notified.
            </p>
          </>
        )}
      </Flex>
      {['review', 'appealRejection'].includes(type) && (
        <Box
          as="form"
          onSubmit={handleSubmit(handleSendClick)}
          sx={{ width: '100%', mt: '30px' }}
        >
          <TextInput {...field} placeholder="Type optional message here" />
        </Box>
      )}
      <Flex sx={{ justifyContent: 'center', gap: 'm', mt: 'l', mb: 'l' }}>
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={handleSubmit(handleSendClick)} disabled={disabled}>
          {type === 'deactivate' ? 'Continue ' : 'Send'}
        </Button>
      </Flex>
    </Modal>
  );
};

export default NudgeCnpModal;
